(function () {
  var module = namespace.create('leica.pi.util');
  var global = namespace.create('leica.pi.global');

  /**
   * Creates a really simple event bus. You can subscribe (but not unsubscribe). Because YAGNI.
   * @constructor
   */
  module.EventChannel = function EventChannel () {
    var listeners = {};

    this.on = function (name, callback){
      if (!listeners[name]) {
        listeners[name] = [];
      }
      listeners[name].push(callback);
    };

    this.trigger = function (name) {
      if (!listeners[name]) {
        return;
      }
      var args = Array.prototype.slice.call(arguments, 1);
      listeners[name].forEach(function (listener) {
        // Handle events so callers' main flow aren't interrupted.
        try {
          listener.apply(null, args);
        } catch (e) {
          // For debugging, mostly.
          console.error('Error in ' + name + ' event handler.', e);
        }
      });
    };
  };

  // Create a global bus.
  global.events = new module.EventChannel();
}());
